import type { LogoutState } from './types';

export const initialLogoutState: LogoutState = {
  dialogOpen: false,
  loading: false
};
